import React, { useEffect, useRef } from 'react';

import './CircularGallery.css';
import meatImg from './meat.jpg';
import serviceImg from './service.jpg';
import breadImg from './bread.jpg';
import sauceImg from './sauce.jpg';
import toppingsImg from './toppings.jpg';
import communityImg from './community.jpg';

import e1Img from './e1.jpg';
import e2Img from './e2.jpg';
import e3Img from './e3.jpg';
import './Navbar.css';

export default function CircularGallery({ items }) {
    const defaultImages = [serviceImg, e2Img, e1Img, sauceImg, meatImg, toppingsImg, e3Img, breadImg, communityImg];
    const baseImages = items && items.length ? items.map(item => item.image) : defaultImages;
    // Triple the images for seamless infinite loop
    const galleryImages = [...baseImages, ...baseImages, ...baseImages];
    
    return (
        <div className="fallback-gallery">
            <div className="fallback-gallery-scroll infinite-scroll">
                {galleryImages.map((img, index) => (
                    <img 
                        key={index} 
                        src={img} 
                        alt={`Gallery ${index + 1}`}
                        className="fallback-gallery-image"
                    />
                ))}
            </div>
        </div>
    );
}
